import { useSessionAuth } from '@/context/Auth';
import { searchChatRooms } from '@/infrastructure/api/chat';
import { ChatRoom } from '@/infrastructure/domain/chat';
import { EntityType } from '@/infrastructure/domain/entity';
import { ListResponse } from '@/infrastructure/domain/list';
import { UseQueryResult, useQuery } from '@tanstack/react-query';

export const useSearchChatRooms = (
  entityId: string,
  entityType: EntityType,
): UseQueryResult<ListResponse<ChatRoom>, Error> => {
  const { token } = useSessionAuth();

  return useQuery({
    queryKey: ['chatRooms'],
    queryFn: () => searchChatRooms(token!, entityId, entityType),
  });
};
